import React, {useCallback} from 'react';

export const useContainerCoords = ({containerRef, scale}) => {
    const getXY = useCallback((e) => {
        let el = containerRef.current.getBoundingClientRect();
        let coords = {
            x: e.clientX - el.left,
            y: e.clientY - el.top
        };
        if (scale) {
            coords.x /= scale;
            coords.y /= scale;
        }
        return coords;
    }, [scale]);
    return {getXY};
};

